// src/api/config.ts
/**
 * Configuration for the API client used throughout the web client.
 * This file defines the shape of the configuration object and provides sensible defaults.
 */

export interface ApiClientConfig {
  /** Base URL of the backend API (e.g., https://api.example.com/api/v1) */
  baseUrl: string;
  /** Request timeout in milliseconds */
  timeoutMs?: number;
  /** Additional headers to include on every request */
  defaultHeaders?: Record<string, string>;
}

/**
 * Default configuration values. The `baseUrl` must be overridden at runtime (e.g., via environment
 * variables) because it differs between development and production.
 */
export const defaultApiClientConfig: ApiClientConfig = {
  baseUrl: '', // to be set by the consuming application
  timeoutMs: 15000,
  defaultHeaders: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
};
